'use strict';

import * as types from '@/state/domains/errors/types';

const errorService = () => next => action => {

	if (/_FAILED$/.test(action.type)) {

		if ('code' in action.data && action.data.code === 1) {
			window.location.href = window.location.origin;
			return;
		}

		return next({
			type: types.ADD_ERROR,
			data: action.data,
		});
	}
	return next(action);
};

export default errorService;
